import getLang from 'I18n/utils/getLang';
const ENGLISH = 'en';
export const getIsEnglishLangUser = () => {
  return getLang() === ENGLISH;
};